import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { debugLogger } from '@/utils/debugLogger';
import { showSuccessToast, showErrorToast } from '@/utils/toastUtils';

interface MissionStepValidation {
  step_id: string;
  day_number: number;
  title: string;
  validation_type: string;
  is_completed: boolean;
  progress_id?: string;
}

interface ValidationResponse {
  success: boolean;
  validations: MissionStepValidation[];
  all_completed: boolean;
}

export const useMissionValidation = () => {
  const [validating, setValidating] = useState(false);

  const validateAllMissions = useCallback(async (): Promise<ValidationResponse | null> => {
    setValidating(true);
    try {
      debugLogger.debug('[useMissionValidation] Starting parallel validation');

      const { data, error } = await supabase.functions.invoke(
        'validate-all-missions',
        {
          body: {},
        }
      );

      if (error) {
        throw error;
      }

      if (!data) {
        throw new Error('No data returned from validation');
      }

      debugLogger.debug('[useMissionValidation] Validation complete:', data);

      return data;
    } catch (error) {
      debugLogger.error('[useMissionValidation] Error validating missions:', error);
      showErrorToast({
        title: "Erro na validação",
        description: "Não foi possível validar suas missões. Tente novamente."
      });
      return null;
    } finally {
      setValidating(false);
    }
  }, []);

  return {
    validateAllMissions,
    validating
  };
};
